import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { Breadcrumbs } from '../generic/Breadcrumbs';

interface Props extends ChakraV3.FlexProps {
  headerContent?: JSX.Element;
}

export const ContentLayout = (props: React.PropsWithChildren<Props>) => {
  const { children, headerContent, ...rest } = props;
  return (
    <ChakraV3.Flex flexDir='column' h='full' {...rest}>
      <ChakraV3.Box px={6} py={4}>
        <Breadcrumbs />
        {headerContent && <ChakraV3.Box mt={2}>{headerContent}</ChakraV3.Box>}
      </ChakraV3.Box>
      <ChakraV3.Box h='full' minH='0'>
        {children}
      </ChakraV3.Box>
    </ChakraV3.Flex>
  );
};
